import { SupersetClient } from '@aibi-ui/core';

// 获取token
export const getTokenAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/security/login',
    jsonPayload,
  });

// 获取csrf_token
export const getCsrfTokenAPI = token =>
  SupersetClient.get({
    endpoint: '/api/v1/security/csrf_token',
    headers: { Authorization: `Bearer ${token}` },
  });

// 登录
export const postLoginAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/aibi/login/',
    jsonPayload,
  });
